<div class="dot-spinner">
  <span class="is-left" [ngClass]="theme()"></span>
  <span class="is-centered" [ngClass]="theme()"></span>
  <span class="is-right" [ngClass]="theme()"></span>
</div>
